export class AppUser {
  Email: string;
  Fname: string;
  Lname: string;
  Phone: string;
  Password: string;
  Domain: string;
}

export class JWTUser {
  email: string;
  domain: string;
  name: string;
  id: Number;
  token: string;
  isEnabled: boolean;
  allowCombo: boolean;
  maxCombo: number;
  selectedSubjects: Array<string>;
  loggedInTime: Date;
  mandatorySubjects: Array<string>
}

export class SubjectsModel {
  email: string;
  domain: string;
  subjects: Array<string>;
}

export class TransactionListModel {
  date: string;
  attempts: Number;
  attemptsUsed: Number;
  attemptsRemaining: Number;
  expiry: string;
  active: boolean;
}

export class DashboardDetails {
  credits: number;
  creditExpiryDate: Date;
  name: string;
  attempts: Array<AttemptHistory>;
  totalAttempts:number;
}

export class AttemptHistory {
  user: string;
  domain: string;
  score: number;
  dateUTC: Date;
  scheduleId: number;
  examNo: string;
  examID: number;
  subjects: Array<string>;
  subjectsScores: Array<any>;
}
export class PaymentHistory {
  user: string;
  domain: string;
  amount: number;
  dateUTC: Date;
  credits: number;
  status: string;
  id: number;
}